import { type FC } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface PlatformPagesFilterProps {
  onCreatePage: () => void;
}

export const PlatformPagesFilter: FC<PlatformPagesFilterProps> = ({
  onCreatePage,
}) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("platformPages.filter.title")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={onCreatePage}
        >
          {t("common.actions.add")}
        </Button>
      }
      fields={{
        search: true,
      }}
    />
  );
};
